export default __webpack_public_path__ + "static/media/lupa.36876e10.svg";